/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 */

import gql from "graphql-tag";

export const CREATE_TEMPLATE_COSTUME_FEATURE = gql`
  mutation CreateCostumeFeature($data: CostumeFeatureCreateInput!) {
    createCostumeFeature(data: $data) {
      id
    }
  }
`;
